<template>
    <div>
        <BackButton />

        <div class="inner-content left" v-if="selectedClient != null && !loading">
            <h1>{{$t('client_reschedule.title', {name : formatClient(selectedClient)})}}</h1>

            <!-- meting met 1 persoon of uit ergosleep CRM -->
            <div v-if="clients.length <= 1" class="content">
                <div v-html="$t('client_reschedule.1client', {name: '<b>'+ formatClient(selectedClient) +'</b>'})">
                </div>

                <div class="btns">
                    <button class="btn-basic blue small"
                        v-html="$t('client_reschedule.btn1_1', {name : formatClient(selectedClient)})"
                        @click.prevent="clickReschedule(selectedClient)"
                    ></button>

                    <button class="btn-basic blue small"
                        @click.prevent="clickRescheduleWithNewClient(selectedClient)"
                        v-if="!offline"
                        v-html="$t('client_reschedule.btn1_2', {name : formatClient(selectedClient)})"
                    ></button>
                </div>
            </div>

            <!-- gekoppelde meting -->
            <div v-if="clients.length == 2" class="content">
                <p path="client_reschedule.2clients" tag="p" >
                    <b>
                        (<router-link :to="{
                            name : 'client-detail',
                            params : {ergosleep_id:otherClient.ergosleep_id}}">{{formatClient(otherClient)}}</router-link>)
                    </b>
                </p>
                <p>
                    {{$t('client_reschedule.2clients_2')}}
                </p>

                <div class="btns">
                    <button class="btn-basic blue small"
                        v-html="$t('client_reschedule.btn1_1', {name : formatClient(selectedClient)})"
                        @click.prevent="clickReschedule(selectedClient)"
                    ></button>
                    <button class="btn-basic blue small"
                        v-html="$t('client_reschedule.btn1_1', {name : formatClients(clients)})"
                        @click.prevent="clickRescheduleClients(clients)"
                    ></button>
                </div>
            </div>
        </div>

        <Loading v-if="loading" />
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import Loading from "@/components/app/Loading.vue";
import {apiStore} from "@/stores/api";

export default {
    name : "ClientReschedule",
    components : {
        BackButton,
        Loading
    },

    data() {
        return {
            selectedClient: null,
            loading : true,
            clients : [],
            offline : false
        };
    },

    computed: {
        otherClient() {
            return this.clients.find(x => x.id !== this.selectedClient.id);
        }
    },

    async created() {
        this.selectedClient = this.$route.params.client;

        if (this.selectedClient === undefined || this.selectedClient.ergosleep_id === undefined) {
            this.selectedClient = (await apiStore().getErgosleepUserById(this.$route.params.ergosleep_id)).client;
        }
        try {
            this.clients = await apiStore().getAppointmentForErgosleepId(this.selectedClient.ergosleep_id);

        } catch (error) {
            console.log("error fetching ergosleep id data");
            this.offline = true;
        }

        this.loading = false;
    },

    methods: {
        async clickReschedule(client) {
            let appointment;
            try {
                appointment = await this.reschedule(client.ergosleep_id);
            } catch (error) {
                console.log("reschedule error", error);
            }

            if (apiStore().shop && apiStore().shop.show_service_type === true) {
                this.$router.push({name : "appointment-type", params : {id : appointment.id, nextRoute: "appointment-schedule"}});
            } else {
                this.$router.push({name : "appointment-schedule", params : {id : appointment.id}});
            }
        },

        async clickRescheduleClients(clients) {
            const appointment = await this.reschedule(clients.map(c => c.ergosleep_id));

            if (apiStore().shop && apiStore().shop.show_service_type === true) {
                this.$router.push({name : "appointment-type", params : {id : appointment.id, nextRoute: "appointment-schedule"}});
            } else {
                this.$router.push({name : "appointment-schedule", params : {id : appointment.id}});
            }
        },

        async clickRescheduleWithNewClient(client) {
            const appointment = await this.reschedule(client.ergosleep_id);
            this.$router.push({name : "appointment-edit", params : {id : appointment.id}, query: {addClient: true}});
        },

        async reschedule(data) {
            this.loading = true;
            const appointment = await apiStore().rescheduleClients(data, this.$i18n.locale);
            this.loading = false;
            return appointment;
        },

        formatClient(client) {
            return client.firstname + " " + client.lastname;
        },

        formatClients(clients) {
            return clients.map(c => this.formatClient(c)).join(" & ");
        }
    }
};
</script>

<style lang="scss" scoped>
    .content {
        @include slideIntroAnimation(basicSlideIntro, 750ms, 650ms);
    }

    .btns {
        .btn-basic {
            margin-right: 1rem;
            margin-top : 2rem;
        }

    }
</style>